import { IGetRemittanceParams, IRemittanceItemRepositoryResponse, IRemittanceRepository } from "@/core/repositories/remittance";

export class GetRemittanceItemUseCase {
  constructor(private readonly remittanceRepository: IRemittanceRepository) {}

  async execute(params: IGetRemittanceParams, refetch: boolean = false): Promise<IRemittanceItemRepositoryResponse> {
    return this.remittanceRepository.getRemittanceItems(params, refetch);
  }
}
